<template>
  <v-card>
    <v-btn @click="$emit('close')" absolute right class="mt-3" icon>
      <v-icon>fas fa-times</v-icon>
    </v-btn>
    <v-btn class="mr-12 mt-3" style="min-width: auto" absolute right color="primary" small @click="print">
      <v-icon>fas fa-print</v-icon>
    </v-btn>
    <v-card-text id="taxDebtInfoWrap">
      <v-card-title><h4 style="word-break: normal; padding-right: 65px">Налоговая задолженность</h4></v-card-title>
      <column-table v-if="userData" :data="userData" :rows="userDebtHeaders"/>
    </v-card-text>
  </v-card>
</template>

<script>
import ColumnTable from "@/components/ui/table/ColumnTable";
import printTaxInfoMixin from "@/components/calculation/calculator-tax/printTaxInfoMixin";

export default {
  name: 'InfoTaxDebt',
  props: {
    userData: {
      type: Object
    }
  },
  data() {
    return {
      userDebtHeaders: [
        {
          text: 'Код области',
          value: 'ns10_code'
        },
        {
          text: 'Код района',
          value: 'ns11_code'
        },
        {
          text: 'ИНН',
          value: 'tin'
        },
        {
          text: 'Наименование Юр. Лица',
          value: 'company_name'
        },
        {
          text: 'Дата, на которую возникла налоговая задолженность',
          value: 'ned_date'
        },
        {
          text: 'Код налога',
          value: 'na2_code'
        },
        {
          text: 'Сумма задолженности',
          value: 'ned_summa'
        },
        {
          text: 'Сумма пени',
          value: 'pen_summa'
        }
      ]
    }
  },
  components: {ColumnTable},
  mixins:[printTaxInfoMixin('taxDebtInfoWrap')]
}
</script>